import { Icons, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { TooltipContent } from 'components/Tooltip/Tooltip.styled';
import { ReactNode, useState } from 'react';

const { InfoCircle } = Icons;

export const InfoCircleTooltip = ({
  tooltip,
  infoCircleStyle,
  contentStyle,
}: {
  tooltip?: ReactNode;
  infoCircleStyle?: React.CSSProperties | undefined;
  contentStyle?: React.CSSProperties | undefined;
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Tooltip
      placement="right"
      isOpen={tooltipOpen}
      overlay={<TooltipContent style={contentStyle}>{tooltip}</TooltipContent>}
      trigger={
        <InfoCircle
          width={20}
          height={20}
          onTouchStart={() => setTooltipOpen((current) => !current)} // mobile tapping to open tooltip
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)}
          {...(infoCircleStyle ? { style: infoCircleStyle } : {})}
        />
      }
    />
  );
};
